export default {"src":"/_next/static/media/steam.46db4fa8.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};